import { render } from "./Page.vue?vue&type=template&id=3085adce"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
script.render = render

export default script